module.exports = __webpack_public_path__ + "e7dea25d2340a98e279c6a85a7accbda.png";